import "mdn-polyfills/Object.assign";
import 'url-search-params-polyfill';
import 'url-polyfill';

import {FallcoClass} from "../classes/FallcoClass";

/**
 * @class
 */
class FallcoSettings {
  constructor(add_self_to_namespace) {
    /**
     * @default "fallco"
     * @type {string}
     */
    this.namespace = "fallco";
    /**
     *
     * @type {boolean}
     * @readonly
     */
    this.debug         = this._check_for_debug_mode();
    this.test          = false;
    this.loading_event = "load";
    
    if (!FallcoClass) {
      return;
    }
    let fallco_class = new FallcoClass();
    
    if (!this._check_component("settings")) {
      this._add_component("settings", fallco_class._return_public_methods(this));
    }
    
    if (add_self_to_namespace) {
      return this._check_component("settings");
    } else {
      return this;
    }
  }
  
  /**
   *
   * @return {boolean}
   * @private
   */
  _check_for_debug_mode() {
    let hostname     = window.location.host.split(".")[0];
    let fallco_debug = window.location.search.indexOf("fallco_debug=true") > -1;
    
    return ["localhost", "locale", "test"].indexOf(hostname) > -1 || fallco_debug;
  }
  
  /**
   * Controlla l'essitenza del namespace nell'oggetto window.
   * Nel caso non esista, lo aggiunge.
   *
   * @param {boolean} [check_without_add=false] - Non aggiunge il namespace all'oggetto window nel caso non esista.
   * @return {object|boolean}
   * @private
   */
  _check_namespace(check_without_add) {
    if (!window[this.namespace] && !check_without_add) {
      window[this.namespace] = {}
    }
    
    return window[this.namespace] || false;
  }
  
  /**
   *
   * @param {string} name
   * @return {*|boolean}
   * @private
   */
  _check_component(name) {
    this._check_namespace();
    
    return window[this.namespace][name] || false;
  }
  
  /**
   * Aggiunge un determinato componente al namespace.
   * @private
   * @return {Object}
   */
  _add_component(name, content) {
    this._check_namespace();
    
    if (!window[this.namespace][name]) {
      window[this.namespace][name] = content;
    }
    
    return window[this.namespace][name];
  }
  
  /**
   * Sposta tutto quello che c'è nel namespace attuale, nel nuovo namespace
   *
   * @param {string} new_namespace
   */
  change_namespace(new_namespace) {
    // Controllo cha il nuovo namespace non sia già utilizzato.
    if (window[new_namespace]) {
      return console.warn("Non \u00E8 stato possibile effettuare il cambio del namespace in quanto \u00E8 gi\u00E0 in uso.")
    }
    
    window[new_namespace] = window[this.namespace];
    
    window[this.namespace] = undefined;
    
    this.namespace = new_namespace;
  }
}

export default () => new FallcoSettings(true);
export {FallcoSettings};
